 
import React, { Component } from "react";
import ReactDOM from 'react-dom'; 
import axios from "axios";
import { LangContext } from "../LangContext.jsx";
import Picker from 'react-month-picker';
import 'react-month-picker/css/month-picker.css';

class DeletePeriodsModal extends Component {
    static contextType = LangContext;

    constructor(props) {
        super();
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1; 
        this.state = { 
            deleteDocuments:[],
            documents:[], 
            selectedDocuments: {},
            rangeValue: { from: { year: currentYear, month: currentMonth }, to: { year: currentYear, month: currentMonth } }, 
        }; 
        this.handleOpenModalDeletePeriods = this.handleOpenModalDeletePeriods.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.pickRange = React.createRef();
        this.handleSelectAll = this.handleSelectAll.bind(this);
    } 

    handleSelectAll() {
        const allSelected = Object.values(this.state.selectedDocuments).every(v => v);
        const newSelectedDocuments = Object.keys(this.state.selectedDocuments).reduce((acc, id) => ({
            ...acc,
            [id]: !allSelected,
        }), {});
        this.setState({ selectedDocuments: newSelectedDocuments });
    }
    async getDocuments(){ 
        const { selectedDocuments, rangeValue } = this.state;
        const selectedDocumentIds = Object.keys(selectedDocuments).filter(id => selectedDocuments[id]);        
        console.log(selectedDocumentIds);
        const url = '/api/providers/dossiers/documents/recurrents/'+this.props.person_provider_id;
        const response = await axios.get(url); 
        const documents = response.data; 
        if(documents.length== 0){
            swal.fire({
                text: "No cuentas con plantillas de recurrencia mensual ",
                icon: "info",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            })
        }else{
            $('#deletePeriodsModal').modal('show');
            const selectedDocuments = documents.reduce((acc, doc) => ({ ...acc, [doc.document.id]: true }), {}); 
            this.setState({ documents, selectedDocuments },function(){
                axios.get('/api/periods/generate',{
                    params: {
                        documents: selectedDocuments,
                        from_year: rangeValue.from.year,
                        from_month: rangeValue.from.month,
                        to_year: rangeValue.to.year,
                        to_month: rangeValue.to.month,
                        person_provider_id: this.props.person_provider_id,
                        action: 'destroy'
                    }
                }).then(response => {
                    console.log(response)
                   this.setState({deleteDocuments: response.data});
                })
            }); 
        } 
    }

    handleOpenModalDeletePeriods() {  
        this.getDocuments();  
    }

    handleCheckboxChange(event, id) {
        event.stopPropagation(); 
        const { selectedDocuments, rangeValue } = this.state;
        axios.get('/api/periods/generate',{
            params: {
                documents: this.state.selectedDocuments,
                from_year: rangeValue.from.year,
                from_month: rangeValue.from.month,
                to_year: rangeValue.to.year,
                to_month: rangeValue.to.month,
                person_provider_id: this.props.person_provider_id,
                action: 'destroy'
            }
        }).then(response => {
            console.log(response)
            this.deleteDocuments = response.data;
        })
        const { checked } = event.target;
        this.setState(prevState => ({
            selectedDocuments: {
                ...prevState.selectedDocuments,
                [id]: checked,
            }
        }));
    }

    handleButtonClick() {
        Swal.fire({
			html: "¿Estás seguro que deseas borrar las solicitudes de los documentos seleccionados?",
			icon: "warning",
			buttonsStyling: false,
			showCancelButton: true,
			cancelButtonText: 'Cancelar',
			confirmButtonText: "Borrar",
			customClass: {
                cancelButton: "btn font-weight-bold btn-secondary",
                confirmButton: "btn font-weight-bold btn-danger",

            }
		}).then((result) => {
            if (result.isConfirmed) { 
                const { selectedDocuments, rangeValue } = this.state;
                const selectedDocumentIds = Object.keys(selectedDocuments).filter(id => selectedDocuments[id]);        
                axios.post('/api/periods/generate', {
                    documents: selectedDocumentIds,
                    from_year: rangeValue.from.year,
                    from_month: rangeValue.from.month,
                    to_year: rangeValue.to.year,
                    to_month: rangeValue.to.month,
                    person_provider_id:this.props.person_provider_id,
                    action:'destroy'
                })
                .then(response => {
                    swal.fire({
                        text: 'Se han borrado las solicitudes de documentos seleccionadas',
                        icon: "success",
                        buttonsStyling: false,
                        confirmButtonText: 'Aceptar',
                        customClass: {
                            confirmButton: "btn font-weight-bold btn-primary"
                        },
                        timer: 3000
                    }).then(function(result) {
                        location.reload()
                    });
                })
                .catch(error => {
                    console.error(error);
                });
                return;
            } 
        });
                
    }

    handleRangeChange = (year, month, idx) => {
        const { rangeValue } = this.state;
        const newRangeValue = { ...rangeValue };

        if (idx === 0) {
            newRangeValue.from = { year, month };
        } else {
            newRangeValue.to = { year, month };
        }

        this.setState({ rangeValue: newRangeValue });
    };

    getDeletedDocuments = () => {
        const { rangeValue } = this.state;
        axios.get('/api/periods/generate',{
            params: {
                documents: this.state.selectedDocuments,
                from_year: rangeValue.from.year,
                from_month: rangeValue.from.month,
                to_year: rangeValue.to.year,
                to_month: rangeValue.to.month,
                person_provider_id: this.props.person_provider_id,
                action: 'destroy'
            }
        }).then(response => {
            console.log(response)
            this.setState({deleteDocuments: response.data}); 
        })
    }

    handleRangeDismiss = (value) => {
        this.getDeletedDocuments();
        console.log('Range dismissed:', value);
    };

    handleClickRangeBox = () => {
        this.pickRange.current.show();
    }; 
    render() {
        const pickerLang = {
            months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            from: 'From', to: 'To',
        };

        const makeText = (m) => {
            if (m && m.year && m.month) return (pickerLang.months[m.month - 1] + '. ' + m.year);
            return '?';
        };

        const { rangeValue, documents, selectedDocuments, deleteDocuments } = this.state;
        const { lang } = this.context;
        const deletedCounts = deleteDocuments.reduce((acc, group) => {
            group.forEach(doc => {
                acc[doc.document_id] = (acc[doc.document_id] || 0) + 1;
            });
            return acc;
        }, {});
        return (

            
            <div className="modal fade" id="deletePeriodsModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalSizeSm" arian-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                    <div className="modal-content" style={{ background: '#f5f5f5' }}>
                        <div className="modal-body px-15 py-5"> 
                            <h5 className="text-dark font-weight-bold my-1 mr-5">
                                Borrar solicitud de documento (s) con frecuencia mensual 
                            </h5>
                            <div className="text-muted"> 
                                Selecciona el período de los documentos solicitados que deseas borrar de tú expediente
                            </div>
                            <div className="card card-custom  gutter-b my-5"> 
                                <div className="card-body pt-5 height-500"> 
                                    <div className="mb-5">
                                        <div className="col-md-12">
                                            <table>
                                                <tr>
                                                    <td></td>
                                                    <td className="datepicker-text">Del</td> 
                                                    <td className="datepicker-text text-date-right">Hasta</td>
                                                </tr>
                                                <tr>
                                                    <td className="pr-3">
                                                        Periodo
                                                    </td>
                                                    <td colSpan={2}> 
                                                        <Picker
                                                        ref={this.pickRange}
                                                        years={{ min: 2013 }}
                                                        range={true}
                                                        value={rangeValue}
                                                        lang={pickerLang}
                                                        theme="light"
                                                        onChange={this.handleRangeChange}
                                                        onDismiss={this.handleRangeDismiss}   >
                                                <div className="month-box" onClick={this.handleClickRangeBox}>
                                                        <span>{makeText(rangeValue.from)}</span> 
                                                        <span>{makeText(rangeValue.to)}</span>
                                                        <i class="flaticon2-down icon-sm"></i>
                                                </div>
                                            </Picker>
                                            </td>
                                                </tr>
                                            </table>
                                        </div> 
                                    </div> 
                                    <div className="d-flex align-items-center py-2 px-4  mb-2">
                                    <div className="symbol symbol-40 symbol-white">
                                        <span className="symbol-label d-flex  ">
                                            <div className="checkbox-inline">
                                                <label className="checkbox checkbox-outline mb-7">
                                                    <input type="checkbox"
                                                        checked={Object.values(selectedDocuments).every(v => v)}
                                                        onChange={this.handleSelectAll} />
                                                    <span className="w-25px h-25px mt-2 rounded-0"></span>
                                                </label>
                                            </div>
                                        </span>
                                    </div>
                                    <div className="d-flex flex-column flex-grow-1">
                                        <span className="text-primary">Seleccionar Todos</span> 
                                        <span className="text-muted">Hay {this.state.deleteDocuments.length} solicitudes de documentos en el período seleccionado</span>
                                    </div> 
                                </div>  
                                    {documents.map((doc, i) => (
                                        <div key={i} className="panel-collapse"> 
                                            <div className="panel d-flex">
                                                <button className="card-collapse " type="button" data-toggle="collapse"    data-target={`#collapse${doc.id}`}   aria-expanded="false" aria-controls="collapseOne"  >
                                                    <i className="flaticon2-plus mr-4 text-primary" style={{"fontSize": "0.80rem"}}></i>
                                                    <i className="flaticon2-line mr-4 text-primary" style={{"fontSize": "0.80rem"}}></i>
                                                </button> 
                                                <div className="checkbox-inline d-flex align-items-center">
                                                    <label className="checkbox checkbox-outline align-items-center mb-2"> 
                                                        <input 
                                                            type="checkbox" 
                                                            name="extensions" 
                                                            onMouseDown={(e) => e.stopPropagation()}  
                                                            checked={selectedDocuments[doc.document.id] || false}
                                                            onChange={(e) => this.handleCheckboxChange(e, doc.document.id)} 
                                                        />
                                                        <span className="w-25px h-25px mt-2 rounded-0"></span>
                                                    </label>
                                                    <i className="flaticon2-files-and-folders icon-lg mr-3 text-primary"></i> 
                                                        {doc.document.title}
                                                    <span class="ml-5 pill">{deletedCounts[doc.document.id] || 0}</span>
                                                </div> 
                                            </div> 
                                            <div  id={`collapse${doc.id}`} className="collapse pb-5" aria-labelledby="headingOne" data-parent="#accordionExample">
                                            {deletedCounts[doc.document.id] > 0 && <div className="element"><strong>Documentos solicitados</strong></div>}
                                            {!deletedCounts[doc.document.id] ? <div className="element"><strong>No existen documentos solicitados en el periodo seleccionado</strong></div> : null}
                                            {this.state.deleteDocuments.map((deletedDoc, i) => {
                                                if (deletedDoc[0].document_id === doc.document.id) {
                                                    return (
                                                        <div key={i} className="element">
                                                            <div className="d-flex">
                                                                <div className="symbol symbol-40 mr-5"> 
                                                                    <div className="symbol-label bg-primary-o-40 text-primary font-weight-bolder">{ doc.document.title[0] }</div>
                                                                </div>
                                                                <div>
                                                                    {doc.document.title} - <strong> {deletedDoc[0].description_period}</strong>
                                                                    <div className="text-dark-65 font-size-sm">
                                                                    (Solicitado el  { deletedDoc[0].created   } ) 
                                                                    </div> 
                                                                </div>
                                                            </div> 
                                                        </div>
                                                    );
                                                }
                                            })} 
                                            </div>  
                                        </div>
                                    ))} 
                                </div>
                            </div> 
                        </div>
                        <div className="text-right mb-5 px-15 ">
                            <button className="btn mr-5 btn-secondary font-weight-bolder px-10" data-dismiss="modal">Cancelar</button>
                            <button className="btn btn-danger font-weight-bolder px-10" onClick={this.handleButtonClick} disabled={this.state.deleteDocuments.length === 0}>Borrar</button>
                        </div>    
                    </div>
                </div>
            </div>
        );  }
}

export default DeletePeriodsModal;

if (document.getElementById('DeletePeriodsModal')) {
    ReactDOM.render(<DeletePeriodsModal />, document.getElementById('DeletePeriodsModal'));
}

 